import React from "react";

export const Check = () => (
  <svg
    width={16}
    height={12}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 7l4 4L15 1"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const Pyramid = () => (
  <svg
    width="157"
    height="290"
    viewBox="0 0 157 290"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M78 290V145L157 267.692L78 290Z" fill="#127D7C" />
    <path d="M78 290V145L0 267.692L78 290Z" fill="#1BBCBA" />
    <path d="M78 0L78 145L-4.53269e-06 22.3077L78 0Z" fill="#1ED1CF" />
    <path d="M78 0L78 145L157 22.3077L78 0Z" fill="#159291" />
    <path d="M78.5 45L0 22.5L78.5 0L157 22.5L78.5 45Z" fill="#62DFDD" />
  </svg>
);

export const Github = () => (
  <svg
    width="20"
    height="20.5"
    viewBox="0 0 256 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M128.001 0C57.3173 0 0 57.3067 0 128.001C0 184.555 36.6762 232.536 87.5349 249.461C93.932 250.646 96.2806 246.684 96.2806 243.303C96.2806 240.251 96.1619 230.168 96.1068 219.472C60.4968 227.215 52.9826 204.37 52.9826 204.37C47.16 189.575 38.7704 185.641 38.7704 185.641C27.1569 177.696 39.6458 177.859 39.6458 177.859C52.4993 178.762 59.2674 191.05 59.2674 191.05C70.6838 210.618 89.2116 204.961 96.5159 201.69C97.6647 193.418 100.982 187.771 104.643 184.574C76.2118 181.338 46.3248 170.362 46.3248 121.316C46.3248 107.341 51.3251 95.9224 59.5132 86.9584C58.1842 83.7344 53.8029 70.7156 60.7532 53.0844C60.7532 53.0844 71.5019 49.6442 95.9626 66.205C106.173 63.3689 117.123 61.9466 128.001 61.8978C138.879 61.9466 149.838 63.3689 160.067 66.205C184.498 49.6442 195.232 53.0844 195.232 53.0844C202.199 70.7156 197.816 83.7344 196.487 86.9584C204.694 95.9224 209.66 107.341 209.66 121.316C209.66 170.479 179.716 181.304 151.213 184.473C155.804 188.445 159.895 196.235 159.895 208.177C159.895 225.303 159.747 239.087 159.747 243.303C159.747 246.71 162.051 250.701 168.539 249.444C219.37 232.5 256 184.536 256 128.001C256 57.3067 198.691 0 128.001 0ZM47.9406 182.34C47.6586 182.976 46.6582 183.167 45.7467 182.73C44.8183 182.313 44.2969 181.446 44.5979 180.808C44.8734 180.153 45.876 179.97 46.8023 180.409C47.7328 180.827 48.2627 181.702 47.9406 182.34ZM54.2368 187.958C53.6263 188.524 52.433 188.261 51.6233 187.367C50.786 186.475 50.6292 185.281 51.2481 184.707C51.8776 184.141 53.035 184.406 53.8743 185.298C54.7116 186.201 54.8748 187.386 54.2368 187.958ZM58.5562 195.146C57.772 195.691 56.4896 195.18 55.6968 194.042C54.9126 192.904 54.9126 191.539 55.7138 190.992C56.5087 190.445 57.772 190.937 58.5753 192.066C59.3575 193.224 59.3575 194.589 58.5562 195.146ZM65.8614 203.471C65.1598 204.245 63.6654 204.037 62.5717 202.982C61.4525 201.949 61.1409 200.485 61.8446 199.711C62.5547 198.935 64.0575 199.153 65.1598 200.201C66.2705 201.231 66.6096 202.706 65.8614 203.471ZM75.3025 206.282C74.993 207.284 73.5538 207.74 72.104 207.314C70.6563 206.875 69.7088 205.701 70.0013 204.688C70.3023 203.679 71.7479 203.204 73.2083 203.66C74.6539 204.096 75.6035 205.262 75.3025 206.282ZM86.0469 207.474C86.083 208.529 84.8536 209.405 83.3317 209.424C81.8013 209.458 80.5634 208.603 80.5465 207.565C80.5465 206.499 81.7483 205.632 83.2787 205.606C84.8006 205.577 86.0469 206.424 86.0469 207.474ZM96.6021 207.069C96.7844 208.099 95.7267 209.157 94.2154 209.439C92.7296 209.71 91.3539 209.074 91.1653 208.053C90.9809 206.997 92.0576 205.939 93.5414 205.666C95.0548 205.403 96.4093 206.022 96.6021 207.069Z"
      fill="currentColor"
    />
  </svg>
);
export const Twitter = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.29 16.2534C13.837 16.2534 17.965 10.0004 17.965 4.5784C17.965 4.4004 17.965 4.2234 17.953 4.0484C18.7562 3.46693 19.4493 2.74701 20 1.9224C19.2511 2.2544 18.4566 2.47216 17.643 2.5684C18.4996 2.05546 19.1408 1.24875 19.447 0.298398C18.6417 0.776285 17.7607 1.11313 16.842 1.2944C16.2234 0.636163 15.405 0.200233 14.5136 0.0541031C13.6222 -0.0920265 12.7075 0.0597974 11.9111 0.486067C11.1147 0.912337 10.4811 1.58927 10.1083 2.41206C9.7355 3.23485 9.64437 4.15758 9.849 5.0374C8.21759 4.95564 6.6216 4.53172 5.16465 3.79317C3.70769 3.05461 2.42233 2.01792 1.392 0.750398C0.867318 1.6536 0.706589 2.72282 0.942536 3.74036C1.17848 4.75791 1.79337 5.64728 2.662 6.2274C2.00926 6.2085 1.37063 6.0329 0.8 5.7154V5.7674C0.800389 6.71469 1.1284 7.6327 1.7284 8.36576C2.3284 9.09881 3.16347 9.60179 4.092 9.7894C3.48781 9.95411 2.85389 9.97806 2.239 9.8594C2.50116 10.6749 3.01168 11.388 3.69913 11.899C4.38658 12.41 5.21657 12.6934 6.073 12.7094C5.22212 13.378 4.24779 13.8722 3.20573 14.1639C2.16367 14.4556 1.07432 14.539 0 14.4094C1.8766 15.6137 4.06019 16.2525 6.29 16.2494"
      fill="currentColor"
    />
  </svg>
);

export const LinkedIn = () => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.838 16.338H14.17V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.514v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711h-.001zM5.505 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.84v-8.59H4.167v8.59h.001zM18.168 1H2.828C2.095 1 1.5 1.581 1.5 2.298v15.403c0 .717.595 1.299 1.328 1.299h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19.5 1.581 18.902 1 18.168 1z"
      fill="currentColor"
    />
  </svg>
);

export const Medium = () => (
  <svg
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2814 6.39222C11.2814 9.41142 8.75591 11.859 5.64078 11.859C2.52564 11.859 0 9.41142 0 6.39222C0 3.37301 2.52545 0.925293 5.64078 0.925293C8.7561 0.925293 11.2814 3.37301 11.2814 6.39222Z"
      fill="currentColor"
    />
    <path
      d="M17.4689 6.40401C17.4689 9.24594 16.2062 11.5507 14.6485 11.5507C13.0909 11.5507 11.8281 9.24594 11.8281 6.40401C11.8281 3.56208 13.0907 1.25732 14.6483 1.25732C16.206 1.25732 17.4687 3.56134 17.4687 6.40401"
      fill="currentColor"
    />
    <path
      d="M19.9993 6.40701C19.9993 8.95268 19.5553 11.0176 19.0074 11.0176C18.4595 11.0176 18.0156 8.95323 18.0156 6.40701C18.0156 3.86078 18.4597 1.79639 19.0074 1.79639C19.5551 1.79639 19.9993 3.8606 19.9993 6.40701Z"
      fill="currentColor"
    />
  </svg>
);

export const Discord = () => (
  <svg
    width="20"
    height="15"
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9308 1.21638C15.6561 0.653372 14.2892 0.238571 12.8599 0.000996592C12.8339 -0.00358851 12.8079 0.00786991 12.7945 0.0307873C12.6187 0.331764 12.4239 0.724413 12.2876 1.03303C10.7503 0.811505 9.22099 0.811505 7.71527 1.03303C7.57887 0.717553 7.37707 0.331764 7.20048 0.0307873C7.18707 0.00863455 7.16107 -0.00282388 7.13504 0.000996592C5.70659 0.237811 4.33963 0.652613 3.06411 1.21638C3.05307 1.22097 3.04361 1.22861 3.03732 1.23854C0.444493 4.96719 -0.265792 8.6042 0.0826501 12.1961C0.0842267 12.2137 0.0944749 12.2305 0.108665 12.2412C1.81934 13.4504 3.47642 14.1846 5.10273 14.6712C5.12876 14.6788 5.15634 14.6697 5.1729 14.649C5.55761 14.1433 5.90054 13.6101 6.19456 13.0494C6.21192 13.0166 6.19535 12.9776 6.15989 12.9646C5.61594 12.766 5.098 12.5238 4.59977 12.2488C4.56037 12.2267 4.55721 12.1724 4.59347 12.1464C4.69831 12.0708 4.80318 11.9921 4.9033 11.9127C4.92141 11.8982 4.94665 11.8951 4.96794 11.9043C8.24107 13.3427 11.7846 13.3427 15.0191 11.9043C15.0404 11.8944 15.0657 11.8974 15.0846 11.9119C15.1847 11.9914 15.2895 12.0708 15.3952 12.1464C15.4314 12.1724 15.4291 12.2267 15.3897 12.2488C14.8914 12.5292 14.3735 12.766 13.8288 12.9638C13.7933 12.9768 13.7775 13.0166 13.7949 13.0494C14.0952 13.6093 14.4381 14.1426 14.8157 14.6483C14.8315 14.6697 14.8599 14.6788 14.8859 14.6712C16.5201 14.1846 18.1772 13.4504 19.8879 12.2412C19.9028 12.2305 19.9123 12.2145 19.9139 12.1969C20.3309 8.04423 19.2154 4.43705 16.9568 1.23929C16.9513 1.22861 16.9419 1.22097 16.9308 1.21638ZM6.68335 10.009C5.69792 10.009 4.88594 9.13817 4.88594 8.06869C4.88594 6.9992 5.68217 6.12836 6.68335 6.12836C7.69239 6.12836 8.49651 7.00685 8.48073 8.06869C8.48073 9.13817 7.68451 10.009 6.68335 10.009ZM13.329 10.009C12.3435 10.009 11.5316 9.13817 11.5316 8.06869C11.5316 6.9992 12.3278 6.12836 13.329 6.12836C14.338 6.12836 15.1421 7.00685 15.1264 8.06869C15.1264 9.13817 14.338 10.009 13.329 10.009Z"
      fill="currentColor"
    />
  </svg>
);

export const Logo = () => (
  <svg
    width="177"
    height="28"
    viewBox="0 0 177 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0.501378V27.4986H4.39996V0.501378H0Z" fill="black" />
    <path
      d="M18.4138 7.55923C15.8602 7.55923 13.9352 8.79339 12.9531 10.6061L12.6388 7.98347H9.02457V27.4986H13.1888V17.124C13.1888 13.5758 14.8781 11.5702 17.2745 11.5702C19.4352 11.5702 20.653 12.9972 20.653 15.6584V27.4986H24.8566V14.8485C24.8566 10.4132 22.5387 7.55923 18.4138 7.55923Z"
      fill="black"
    />
    <path
      d="M35.0321 7.55923C32.8714 7.55923 31.1428 8.17631 29.925 9.3719C28.7071 10.5675 28.1178 11.9945 28.1178 13.6915C28.1178 16.8154 30.0428 18.4738 34.3249 19.3609C37.3499 19.978 38.2142 20.6722 38.2142 22.1763C38.2142 23.5647 37.1535 24.4518 35.2285 24.4518C33.1464 24.4518 31.8892 23.4105 31.85 21.5978H27.6464C27.7643 25.4931 30.475 27.9229 35.1499 27.9229C39.3927 27.9229 42.4177 25.686 42.4177 21.7906C42.4177 18.551 40.6499 16.854 35.9356 15.9284C33.1071 15.3113 32.3214 14.7328 32.3214 13.3444C32.3214 11.9945 33.2642 11.0689 34.9535 11.0689C36.7606 11.0689 37.7035 11.9559 37.7428 13.73H41.907C41.8677 11.8788 41.1999 10.3747 39.9034 9.2562C38.6463 8.13774 37.0356 7.55923 35.0321 7.55923Z"
      fill="black"
    />
    <path
      d="M56.8431 7.98347V18.6667C56.8431 22.022 55.1931 23.9504 52.836 23.9504C50.5967 23.9504 49.4967 22.562 49.4967 19.8237V7.98347H45.3325V20.6336C45.3325 25.1074 47.4932 27.9229 51.6967 27.9229C54.2503 27.9229 56.0574 26.9201 57.0788 24.876L57.3538 27.4986H61.0073V7.98347H56.8431Z"
      fill="black"
    />
    <path
      d="M75.5856 7.79063C72.4427 7.79063 70.4785 9.29477 69.7321 11.3003L69.3785 7.98347H65.725V27.4986H69.8892V17.3554C69.9285 15.5427 70.4785 14.1543 71.6177 13.2287C72.6392 12.3416 73.9749 11.9174 75.5856 11.9174V7.79063Z"
      fill="black"
    />
    <path
      d="M86.0266 7.55923C83.1194 7.55923 80.7623 8.52342 78.9945 10.4518C77.2266 12.3416 76.3231 14.8099 76.3231 17.7796C76.3231 20.8264 77.2266 23.2948 78.9945 25.146C80.8016 26.9972 83.1587 27.9229 86.0266 27.9229C90.6229 27.9229 93.7265 25.5702 94.9836 21.5207H90.8979C90.1515 23.3719 88.5801 24.2975 86.1444 24.2975C83.0409 24.2975 80.8409 22.292 80.6445 19.168H95.1408V17.5868C95.1408 11.1074 91.4872 7.55923 86.0266 7.55923ZM85.9873 11.146C88.9337 11.146 90.8979 13.0358 90.9372 15.9669H80.6837C80.9587 13.1515 83.0016 11.146 85.9873 11.146Z"
      fill="black"
    />
    <path
      d="M98.5847 0.501378V27.4986H108.642C112.924 27.4986 116.302 26.2645 118.856 23.7961C121.409 21.3278 122.706 18.0496 122.706 14C122.706 9.95041 121.409 6.71074 118.856 4.24242C116.302 1.73554 112.924 0.501378 108.642 0.501378H98.5847ZM108.642 4.55096C114.652 4.55096 118.188 8.02204 118.188 14C118.188 19.978 114.613 23.449 108.642 23.449H102.985V4.55096H108.642Z"
      fill="black"
    />
    <path
      d="M133.439 0.501378L122.557 27.4986H127.389L129.982 20.9036H141.571L144.204 27.4986H149.036L138.154 0.501378H133.439ZM136.268 7.36639L140.157 17.0083H131.436L135.246 7.36639L135.757 5.90083L136.268 7.36639Z"
      fill="black"
    />
    <path
      d="M162.897 0C158.772 0 155.354 1.3113 152.682 3.97245C150.05 6.59504 148.715 9.91185 148.715 13.9614C148.715 18.011 150.05 21.3664 152.682 24.0275C155.354 26.6887 158.772 28 162.897 28C167.022 28 170.4 26.6887 173.032 24.0275C175.664 21.3664 177 18.011 177 13.9614C177 9.91185 175.664 6.59504 173.032 3.97245C170.4 1.3113 167.022 0 162.897 0ZM153.35 13.9614C153.35 11.0689 154.215 8.71625 155.982 6.86502C157.75 4.97521 160.068 4.04959 162.897 4.04959C165.725 4.04959 168.004 4.97521 169.772 6.86502C171.539 8.71625 172.404 11.0689 172.404 13.9614C172.404 16.854 171.539 19.2452 169.772 21.135C168.004 23.0248 165.725 23.9504 162.897 23.9504C160.068 23.9504 157.75 23.0248 155.982 21.135C154.215 19.2452 153.35 16.854 153.35 13.9614Z"
      fill="black"
    />
  </svg>
);
